import { useContext } from 'react';
import * as R from 'ramda';

import WorkOrderPreviewContext, {
  View,
} from '@atom/components/workOrderPreview/WorkOrderPreviewContext';
import { Icon, IconButton } from '@atom/mui';
import { ArrowBackIcon } from '@atom/mui/icons';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import CustomSection from './CustomSection';
import DetailSection from './DetailSection';
import LocationSection from './LocationSection';
import SummarySection from './SummarySection';

import classes from './infoView.module.css';

const InfoView = () => {
  const { setActiveView, workOrderDetail } = useContext(
    WorkOrderPreviewContext,
  );

  const showCustomFields =
    hasRolePermissions(ROLE_SETS.INSPECTOR) &&
    (!workOrderDetail.workTemplateId || R.length(workOrderDetail.fields) > 0);

  return (
    <>
      <div className={classes.headerContainer}>
        <IconButton onClick={() => setActiveView(View.MAIN)}>
          <Icon icon={ArrowBackIcon} />
        </IconButton>
        <div className={classes.title}>Info</div>
      </div>
      <div className={classes.infoSection}>
        {workOrderDetail.location && <LocationSection />}
        <SummarySection />
        {showCustomFields && <CustomSection />}
        <DetailSection />
      </div>
    </>
  );
};

export default InfoView;
